<template lang="pug">
  .object-fkko
    .toolbar.toolbar_no-padding.toolbar_margin-bottom
      .toolbar__line
        .parameters
          .semibold Перечень групп отходов, допустимых для приема
        .actions-panel
          e-button-add.btn-add-target.actions-panel__button.view-panel__button.view-panel__button_add(
            @click="addNewRowToTable()"
            label="Добавить"
          )
    e-table-editable(
      ref="fkko"
      :attributes="detailAttr"
      :enabledActions="['create','delete']"
      :dataUrl="dataUrl"
      :postUrl="postUrl"
      :patchUrl="patchUrl"
      :deleteUrl="deleteUrl"
      :tableInOnlineMode="true"
      :autoSaveAfterChange="false"
      :afterValidate="afterValidate"
      :afterFetchData="afterFetchData"
    )
</template>

<script>
import { tko, tkoObject, msn, cadastr } from '@/api/api-endpoints'

export default {
  name: 'object-fkko',
  computed: {
    detailAttr() {
      return {
        fkkoName: {
          label: 'Наименование отхода',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название отхода',
          suggestion: {
            options: [],
            onSelect: this.onSelect,
            suggestionEndpoint: this.suggestionEndpoint,
            transformSuggestions: this.transformSuggestions,
          },
        },
        code: {
          label: 'Код ФККО',
          required: true,
          placeholder: 'Введите код',
          validationRulePattern: '^((\\d*\\s*)*)$',
          suggestion: {
            options: [],
            onSelect: this.onSelect,
            suggestionEndpoint: this.suggestionEndpoint,
            transformSuggestions: this.transformSuggestions,
          },
        },
        danger: {
          label: 'Класс опасности',
          placeholder: 'цифра',
          required: true,
          disabled: true,
          validationRulePattern: '^([1-5])$',
        },
        composition: {
          label: 'Компонентный состав',
          disabled: true,
        },
      }
    },
    dataUrl() {
      return tkoObject.fkko(this.$route.params.id)
    },
  },
  methods: {
    postUrl(context, model) {
      return tkoObject.fkkoById(this.$route.params.id, model.id)
    },
    patchUrl(context, model) {
      return msn.garbageOperationPatch(
        this.$route.params.id,
        'operation-detail',
        model.id
      )
    },
    deleteUrl(context, model) {
      return tko.objectFkkoById(model.id)
    },
    afterValidate(ctx, model, errors) {
      return errors
    },
    suggestionEndpoint(ctx, q) {
      return cadastr.fkko({ query: { q: q, 'per-page': 50 } })
    },
    onSelect(ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.code = copy.code
        model.fkko_id = copy.id
        model.id = copy.id
        model.fkkoName = copy.fkkoName
        model.composition = copy.composition
        model.fkko = { name: copy.fkkoName }
        model.danger = copy.danger
      } else {
        model.code = ''
        model.id = ''
        model.fkko_id = ''
        model.fkkoName = ''
        model.composition = ''
        model.fkko = { name: '' }
        model.danger = ''
      }
      this.sendObjectFkkoRequest(model.id)
    },
    async sendObjectFkkoRequest(id) {
      await this.$store.dispatch('createModel', {
        url: tkoObject.fkkoById(this.$route.params.id, id),
      })
    },
    afterFetchData(ctx, data) {
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].fkko) {
          data.data[i].fkkoName = data.data[i].fkko.name

          if (!data.data[i].code) {
            data.data[i].code = data.data[i].fkko.code
          }
          if (!data.data[i].composition) {
            data.data[i].composition = data.data[i].fkko.composition
          }
          if (!data.data[i].danger) {
            data.data[i].danger = data.data[i].fkko.danger
          }
        } else {
          data.data[i].fkkoName = ''
        }
      }

      return data
    },
    transformSuggestions(ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].code + ' ' + data[i].name,
          fkkoName: data[i].name,
          id: data[i].id,
          code: data[i].code,
          danger: data[i].danger,
          composition: data[i].composition,
        })
      }
      return options
    },
    addNewRowToTable() {
      const Model = () => {
        return {
          id: '',
          code: '',
          fkko_id: '',
          danger: '',
          amount: '',
          composition: '',
        }
      }
      this.$refs.fkko.createRow(new Model())
    },
  },
}
</script>

<style scoped lang="scss">
.object-fkko {
  display: flex;
  flex-direction: column;
  min-height: 500px;
  margin-top: 20px;
}
</style>
